"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BVInlineRatingsBase = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var BVLoader_1 = require("../BVLoader");

var asBVComponent_1 = require("../asBVComponent");

var asEditableBV_1 = require("../asEditableBV");

var onLoaded = function onLoaded(_a) {
  var productId = _a.productId; // @ts-ignore since $BV variable is defined in external script

  if (typeof $BV !== 'undefined') {
    // @ts-ignore
    $BV.ui('rr', 'inline_ratings', {
      productIds: productId
    }); // eslint-disable-line no-undef
  }
};

var BVPlainInlineRatings = function BVPlainInlineRatings() {
  return react_1.default.createElement("div", {
    id: "BVRRSummaryContainer"
  });
};

exports.BVInlineRatingsBase = asBVComponent_1.asDesignableBVComponent('BV Inline Ratings', onLoaded)(BVPlainInlineRatings);
var BVInlineRating = lodash_1.flowRight(BVLoader_1.withBVLoader, asEditableBV_1.asEditableBV)(exports.BVInlineRatingsBase);
exports.default = BVInlineRating;